import React from "react";
import { View } from "react-native";

import { CheckBox } from "components";
import { getSelectedOptions } from "state/modules/response/selectors";

import { styles } from "./styles";

export const ConsentQuestion = props => {
  const { question, lang, isEnglish, setConsent, response } = props;
  const [selectedOption] = getSelectedOptions(response, question);
  return (
    <View style={styles.checkbox}>
      <CheckBox
        text={question[lang]}
        styles={styles}
        checked={selectedOption?.score === 0}
        iconRight={!isEnglish}
        onPress={() => setConsent(question, selectedOption)}
      />
    </View>
  );
};
